import clsx from 'clsx'

interface InnerCircleProps {
  active?: string
}
const InnerCircle = ({ active }: InnerCircleProps) => (
  <svg
    width={active?.length ? '200' : '332'}
    height={active?.length ? '200' : '332'}
    viewBox="0 0 333 330"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="path-green"
      className={clsx(active === 'page-produce' && 'active')}
      d="M159.255 22.9043C158.509 9.17504 146.702 -1.53701 133.238 1.25287C116.486 4.72422 100.322 10.7752 85.3359 19.2333C63.0986 31.7841 44.0571 49.2967 29.6931 70.4081C15.329 91.5196 6.0298 115.661 2.519 140.953C0.153071 157.997 0.458896 175.255 3.37998 192.111C5.72762 205.659 20.0262 212.709 33.0709 208.363C46.1156 204.017 52.8751 189.885 51.4026 176.215C50.3876 166.792 50.5261 157.248 51.8378 147.799C54.2954 130.094 60.8048 113.196 70.8596 98.4175C80.9145 83.6395 94.2435 71.3807 109.81 62.5951C118.118 57.9058 126.944 54.2735 136.082 51.7582C149.338 48.1092 160.002 36.6337 159.255 22.9043Z"
      fill="#71D085"
    />
    <path
      id="path-darkYellow"
      className={clsx(active === 'page-shape' && 'active')}
      d="M140.344 302.324C137.754 315.828 124.611 324.851 111.647 320.272C96.5424 314.938 82.248 307.431 69.2274 297.951C49.4763 283.572 33.1433 265.009 21.3944 243.588C9.64554 222.168 2.77054 198.417 1.2602 174.033C0.26454 157.958 1.61649 141.869 5.23646 126.265C8.3437 112.871 23.0167 106.638 35.7958 111.712C48.575 116.786 54.5275 131.276 52.2871 144.842C50.8667 153.443 50.4145 162.202 50.9566 170.955C52.0139 188.024 56.8264 204.649 65.0506 219.644C73.2748 234.638 84.7079 247.632 98.5337 257.698C105.624 262.859 113.253 267.186 121.269 270.611C133.913 276.013 142.933 288.821 140.344 302.324Z"
      fill="#E7D394"
    />
    <path
      id="path-copper"
      className={clsx(active === 'page-create' && 'active')}
      d="M287.721 236.631C299.495 243.732 303.415 259.185 294.635 269.765C284.769 281.654 273.265 292.138 260.435 300.889C240.728 314.33 218.355 323.365 194.84 327.379C171.326 331.392 147.222 330.29 124.172 324.147C109.166 320.147 94.836 314.073 81.5852 306.13C69.792 299.061 68.3645 283.183 77.1164 272.579C85.8684 261.974 101.486 260.757 113.709 267.054C121.105 270.864 128.91 273.88 136.995 276.035C153.13 280.335 170.003 281.106 186.463 278.297C202.923 275.487 218.584 269.163 232.379 259.754C239.292 255.039 245.654 249.605 251.368 243.558C260.81 233.563 275.947 229.53 287.721 236.631Z"
      fill="#FAB856"
    />
    <path
      id="path-orange"
      className={clsx(active === 'page-explore' && 'active')}
      d="M266.671 64.0166C276.393 54.2941 292.335 54.2025 300.495 65.2686C310.277 78.5328 318.056 93.2178 323.539 108.857C331.777 132.354 334.624 157.403 331.867 182.149C329.11 206.895 320.821 230.703 307.613 251.811C298.822 265.86 288.002 278.473 275.542 289.26C265.146 298.259 249.616 294.661 242.271 283.037C234.927 271.413 238.644 256.195 248.44 246.547C254.88 240.204 260.579 233.111 265.404 225.399C274.649 210.624 280.451 193.958 282.381 176.636C284.311 159.314 282.319 141.78 276.552 125.332C273.542 116.748 269.544 108.574 264.658 100.969C257.225 89.4017 256.949 73.739 266.671 64.0166Z"
      fill="#FF8E5F"
    />
    <path
      id="path-red"
      className={clsx(active === 'page-assemble' && 'active')}
      d="M175.341 22.9481C176.162 9.22307 188.028 -1.4247 201.476 1.43846C227.571 6.9942 252.07 18.7887 272.803 35.9659C293.536 53.1431 309.68 75.0214 319.991 99.6283C325.305 112.31 317.049 125.948 303.717 129.307C290.384 132.666 277.08 124.394 270.962 112.081C263.777 97.6177 253.613 84.7273 241.036 74.3079C228.46 63.8885 213.905 56.2985 198.358 51.9277C185.121 48.2064 174.52 36.6732 175.341 22.9481Z"
      fill="#F96B6C"
    />
  </svg>
)

export default InnerCircle
